module.exports = __webpack_public_path__ + "school/img/cx.88655afc.png";